import { Button, ButtonGroup } from "@mui/material";
function InsertForm(props) {
  const submitHandler = (e) => {
    e.preventDefault();
    console.log("Saving");
    console.log(e.target["input"].value);
    props.onSubmitted(e.target["input"].value);
  };

  return (
    <form onSubmit={submitHandler}>
      <ButtonGroup variant="text" size="small" aria-label="Add">
        <input id="input" type="text" />
        <Button type="submit" size="small">
          Add
        </Button>
        <Button onClick={props.onCancel}>Cancel</Button>
      </ButtonGroup>
    </form>
  );
}

export default InsertForm;
